export default "__VITE_ASSET__DG5Z_qZn__"